module.exports = __webpack_public_path__ + "img/open.a7b16243.png";